import React, { useMemo } from "react";
import { routeRegistry } from "sulu-admin-bundle/services/Router";
import { useTranslation } from "react-i18next";
import { UrlBuilder } from "../../../utils/urlBuilder";
const urlBuilder = new UrlBuilder();

const MatchListGroup = ({ form }) => {
    const { t } = useTranslation();
    const path = "app.dhbmatches_edit_form_from_league.details";

    const url = useMemo(() => {
        const routes = routeRegistry.getAll();
        const route = routes[path];
        if (!route) return "#";

        const params = {
            locale: "de",
            id: form.id,
        };

        return urlBuilder.generateUrl(route.path, params);
    }, []);

    return (
        <div className="match-list-block-item match-list-group-block">
            <span>{`${t("gamedays.match.group")} ${form?.groups}`}</span>
            <a
                target="_blank"
                href={url}
                style={{
                    cursor: "pointer",
                }}
            >{`${t("gamedays.match.match_id")} ${form?.id}`}</a>
        </div>
    );
};

export default MatchListGroup;
